import { Injectable, inject, signal } from '@angular/core';
import { classes } from 'polytype';
import type { Observable } from 'rxjs';

import type {
    CopyRiskAssessmentBody,
    RiskAssessmentDto,
} from '@app/management/risk-assessment/risk-assessment.dto';
import { RISK_ASSESSMENT_PATH } from '@app/shared/api/api-route.config';
import type { ItemResponse } from '@app/shared/api/crud.service';
import { WithCrudService } from '@app/shared/api/crud.service';
import { RestService } from '@app/shared/api/rest.service';
import { ToastNotificationService } from '@app/shared/notification/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class RiskAssessmentService extends classes(WithCrudService<RiskAssessmentDto>) {
    protected endpoint = RISK_ASSESSMENT_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);

    // FIXME: This is the risk assessment details.
    //        This should ONLY be used when opening a risk assessment page in the Registry
    readonly item = signal<RiskAssessmentDto>(null); // interactions is not present in simple schema

    copyFromPipelineVersion(
        payload: CopyRiskAssessmentBody,
    ): Observable<ItemResponse<RiskAssessmentDto>> {
        return this.api.post<ItemResponse<RiskAssessmentDto>>(`${this.endpoint}copy`, payload);
    }
}
